import * as yup from 'yup';
import searchReportSchema from '@reports/sections/SearchReportForm/schema';

const schema = yup.object().concat(searchReportSchema);

export default schema;
